import { Response } from "@version2/domain-package";

const s200 = {
  GENERAL__SUCCESS: new Response({
    status: 200,
    code: "general/success",
  }),
  GENERAL__NO_CHANGE: new Response({
    status: 204,
    code: "general/no-change",
  }),
};

export default s200;
